import { AccordionSection } from '@medifind/containers';
import { Skeleton } from '@medifind/shared-basic-components';
import classNames from 'classnames';
import styles from './ClinicalTrialShared.module.scss';

const ClinicalTrialDates = ({ startDate, completionDate, isLoading, status }) => {
  return (
    <AccordionSection
      classes={{
        container: styles['accordian-container'],
        header: styles['accordian-header'],
        title: styles['accordian-title'],
        body: styles['accordian-body'],
      }}
      expandable
      title="Time Frame"
      isLoading={isLoading}
    >
      {startDate ? (
        <div>
          {/* Start Date: <time>{trial && trial.startDate}</time> */}
          {!isLoading ? (
            <>
              <span className={classNames(styles['section-body-text'], styles['bold'])}>Start Date:</span> <span>{startDate}</span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
      {completionDate ? (
        <div>
          {/* Completion Date: <time>{trial && trial.completionDate}</time> */}
          {!isLoading ? (
            <>
              <span className={classNames(styles['section-body-text'], styles['bold'])}>
                {['Active, not recruiting', 'Recruiting', 'Open', 'Enrolling by invitation', 'Not yet recruiting'].includes(status)
                  ? 'Estimated '
                  : ''}
                Completion Date:
              </span>{' '}
              <span>{completionDate}</span>
            </>
          ) : (
            <Skeleton width={250} />
          )}
        </div>
      ) : null}
    </AccordionSection>
  );
};

export { ClinicalTrialDates as default, ClinicalTrialDates };
